import { StreamData } from 'types/streamData'
import { AnnotationSentenceKey } from 'types/annotationSentenceKey'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const sentenceKeysResolver: FieldResolver = (metadata: Metadata) => {
  let sentenceKeys
  const sentenceInfos = metadata.getSentenceInfos()
  if (sentenceInfos) {
    sentenceKeys = sentenceInfos.map(
      (sentenceInfo) =>
        ({
          documentPersistId: metadata.getPersistId(),
          documentFingerprint: sentenceInfo.documentFingerprint!,
          sentenceFingerprint: sentenceInfo.sentenceFingerprint!,
          sentenceNumber: sentenceInfo.sentenceNumber!
        } as AnnotationSentenceKey)
    )
  } else if (metadata.getSentenceNumber() !== undefined) {
    sentenceKeys = [
      {
        documentPersistId: metadata.getPersistId(),
        documentFingerprint: metadata.getDocumentId(),
        sentenceFingerprint: metadata.getFingerprint(),
        sentenceNumber: `${metadata.getSentenceNumber()}`
      }
    ]
  }

  return { sentenceKeys } as StreamData
}

export default sentenceKeysResolver
